<template>
  <div class="btn btn-back" @click.prevent="notifyBack">
    <div class="icon"><svg width="32px" height="32px" viewBox="0 0 32 32" version="1.1"
        xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <title>Artboard</title>
        <g id="Artboard" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="Group-4-Copy"
            transform="translate(16.500000, 16.500000) rotate(90.000000) translate(-16.500000, -16.500000) translate(4.000000, 3.000000)"
            stroke="#3C3C3C" stroke-width="2">
            <g id="Group-3"
              transform="translate(12.500000, 11.000000) rotate(-90.000000) translate(-12.500000, -11.000000) translate(2.000000, 2.000000)">
              <path d="M2,9 C19.484375,9 24.8177083,9 18,9" id="Path-4"></path>
              <polyline id="Rectangle"
                transform="translate(9.343146, 9.000000) scale(-1, 1) rotate(45.000000) translate(-9.343146, -9.000000) "
                points="3.34314575 3 15.3431458 3 15.3431458 15"></polyline>
            </g>
            <line x1="0.5" y1="25.6821289" x2="24.5" y2="25.6821289" id="Path-5"></line>
          </g>
        </g>
      </svg></div>
    <div class="label">Conoce más historias</div>
  </div>
</template>
<script>
export default {
  name: 'ButtonBack',
  methods: {
    notifyBack () {
      this.$emit('back')
    }
  }
}
</script>
